import { Link } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { Button } from '@tempo-io/sui-button';
import { Tune } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/common/components/empty-state/EmptyState';
import { useOrgName } from '@/common/hooks/useOrgName';

export const VisualizationNoHeadersState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();
  const org = useOrgName();

  return (
    <EmptyState
      title={t(($) => $.views.visualization.emptyStates.noHeaders.title)}
      description={
        <>
          {visualizationType === 'swimlane' && (
            <p>{t(($) => $.views.swimlane.emptyStates.noHeaders.description)}</p>
          )}
          <p>{t(($) => $.views.visualization.emptyStates.noHeaders.subtitle)}</p>
        </>
      }
      primaryActionNode={
        <Button asChild className="w-60">
          <Link to="/org/$org/settings/custom-fields" params={{ org }}>
            <Tune /> {t(($) => $.views.visualization.emptyStates.noHeaders.button)}
          </Link>
        </Button>
      }
    />
  );
};
